import { EdgeInterfaceDto, IPAssignemntDto } from '../dto/gateway-dto';
import { getEntityStateRenderer } from '../../common/common-renderers';
import CommonConstants from '../../common/common-constants';
import GatewayDto from '../dto/gateway-dto';
export function getGatewayListingDatatableConfig() {
    return {
        dom: 'Bfrtip',
        columns: [
            { 'title': 'Name', 'data': 'name' },
            { 'title': 'Edge Type', 'data': 'edgeType' },
            { 'title': 'Uplink Interfaces', 'data': 'interfaces' },
            { 'title': 'Internal Interfaces', 'data': 'interfaces'},
            { 'title': 'Size', 'data': 'edgeVmSize' },
            { 'title': 'HA', 'data': 'haSettings.enabled' },
            { 'title': 'Scope', 'data': 'scopeId' },
            { 'title': 'Status', 'data': 'state' }
        ],
        columnDefs: [
            {
                'targets': [0],
                 'mRender': function (data, type, row) {
                    if (data) {
                        let displayRenderer: string;
                        if ( (row.state === CommonConstants.STATE.REALIZED || row.state === CommonConstants.STATE.ERROR) && (row.edgeType !== CommonConstants.EDGETYPE.DISTRIBUTED_ROUTER && row.edgeType !== CommonConstants.EDGETYPE.SDDC_GATEWAY) ) {
                            let href: string = '/hybridity/ui/nsx-ui-1.0/index.html?edgeId=' + row.objectId;
                            displayRenderer = '<clr-icon shape="shield" class="is-highlight" size="16"></clr-icon>'
                            + '<a class="icon-text" target="_blank" href="'+ href +'">' + data + ' </a>';
                        } else {
                            displayRenderer = '<clr-icon shape="shield" class="is-highlight" size="16"></clr-icon>'+ '<span class="icon-text">'+ data + '</span>';
                        }
                        return displayRenderer;
                    }
                    return '';
                }
            },
            { 
                'targets': [1] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        let displayRenderer: string;
                        if ( data === CommonConstants.EDGETYPE.DISTRIBUTED_ROUTER ) {
                            displayRenderer = "DLR";
                        } else if ( data === CommonConstants.EDGETYPE.GATEWAY_SERVICES ) {
                            displayRenderer = "ESG";
                        } else {
                            displayRenderer = data;
                        }
                        return displayRenderer;
                    }
                    return '';
                }
            },
            {
                'targets': [2] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        let interfaceDetails: string = '';
                        let interfaces: Array<EdgeInterfaceDto> = data as Array<EdgeInterfaceDto>;
                        interfaces.map(function(edgeInterface, index){
                            if (edgeInterface.type === 'uplink' && edgeInterface.isConnected) {
                                interfaceDetails += edgeInterface.name;
                                if (typeof edgeInterface.addressGroups !== "undefined" && edgeInterface.addressGroups.length > 0) {
                                    interfaceDetails += ' (' + getPrimaryAddress(edgeInterface.addressGroups) + ')';
                                }
                                interfaceDetails += '<br />';
                            }
                         });
                        return interfaceDetails;
                    }
                    return '';
                }
            },
            {
                'targets': [3] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        let interfaceDetails: string = '';
                        let interfaces: Array<EdgeInterfaceDto> = data as Array<EdgeInterfaceDto>;
                        interfaces.map(function(edgeInterface, index){
                            if (typeof edgeInterface.parentInterfaceIndex === "undefined" && edgeInterface.type !== 'uplink' && edgeInterface.isConnected) {
                                interfaceDetails += edgeInterface.name;
                                if (typeof edgeInterface.addressGroups !== "undefined" && edgeInterface.addressGroups.length > 0) {
                                    interfaceDetails += ' (' + getPrimaryAddress(edgeInterface.addressGroups) + ')';
                                }
                                    interfaceDetails += '<br />';
                                }
                        });
                        return interfaceDetails;
                    }
                    return '';
                }
            },
            {
                'targets': [4] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        return data ;
                    } 
                    return '';
                }
            },
             {
                'targets': [5] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        return 'Activated';
                    } else {
                        return 'Deactivated';
                    }
                }
            },
            {
                'targets': [6] ,
                'mRender': function (data, type, row) {
                    let value: string = '';
                    let icon: string = "";
                    let displayRenderer: string;
                    if ( data) {
                        icon = '<clr-icon shape="vc" class="is-highlight" size="16"></clr-icon>';
                        value = row.scopeName;
                    } else {
                        icon = '<clr-icon shape="network-default" class="is-highlight" size="16"></clr-icon>';
                        value = 'Aggregation Router';
                    }
                    displayRenderer = icon + '<span class="icon-text">' + value + '</span>';
                    return displayRenderer;
                }
            },
            { 
                'targets': [7] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        return getEntityStateRenderer(data);
                    }
                    return '';
                }
            }
        ],
        'autoWidth': false,
        'oLanguage': {
            'sSearch': '',
            'sEmptyTable': 'No Routers are available',
            'sInfoEmpty': 'No Routers are available',
            'sProcessing' : '<div class="spinner" aria-hidden="true"></div>'
        },
        'scrollY': '100vh',
        'scrollCollapse': true,
        'paging': false,
        'bFilter': true,
        'bDestroy': true,
        'bUseRendered': false,
        'order': [[0, 'desc']],
        'rowCallback': function (row, data) {
        },
        'processing' : true
    };
}

function getPrimaryAddress(addressGroups: Array<IPAssignemntDto>): string{
    let primaryAddress: string = '';
    addressGroups.map(function(value: IPAssignemntDto, index: number){
        if (index !== 0) {
            primaryAddress += ', ';
        }
        primaryAddress += value.primaryAddress;
    });
    return primaryAddress;
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/listing/gateway-listing.dt.config.ts